import { useRef } from 'react';
import { GTMService, createDataLayerService } from '@wkda/gtm-service';
import Cookies from 'universal-cookie';
import { GTMId } from './constants';

const cookieService = new Cookies();

export function useGTM({ onStart }: { onStart: (script: string) => void }) {
  const gtmService = useRef(
    new GTMService({
      cookieService: cookieService,
      dataLayerService: createDataLayerService(),
      GTMId,
      onStart,
    }),
  );

  return gtmService.current;
}
